import img1 from './web/socialMediaClone.jpg'
import img2 from './web/twoStepSafety.jpg'
import img3 from './web/blogapp.jpg'
import img4 from './web/travelblog.jpg'
import img5 from './web/instagram.jpg'
import img6 from './web/gatepass1.jpg'

export const products = [
    {
      id: 1,
      img: img1,
      link: "https://github.com/sachinkarun/Social-Media-App",
    },
    {
      id: 2,
      img: img2,
      link: "https://github.com/sachinkarun/TwoStepSafety-App",
    },
    {
      id: 3,
      img: img3,
      link: "https://github.com/sachinkarun/BlogApp",
    },
    {
      id: 4,
      img: img4,
      link: "https://travellingblog.netlify.app/",
    },
    {
      id: 5,
      img: img5,
      link: "https://github.com/sachinkarun/Instagram-clone",
    },
    {
      id: 6,
      img: img6,
      link: "https://github.com/sachinkarun/Gatepass-App",
    },
  ];
